var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"item",staticClass:"mm-carousel-item",class:{
    'in-stage': _vm.isInStage,
    active: _vm.index === _vm.current,
  },style:(_vm.itemStyle),on:{"transitionend":_vm.transitionEnd}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }